import { render, staticRenderFns } from "./product-schema-detail.vue?vue&type=template&id=41ccc66e&"
import script from "./product-schema-detail.vue?vue&type=script&lang=js&"
export * from "./product-schema-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ccc66e')) {
      api.createRecord('41ccc66e', component.options)
    } else {
      api.reload('41ccc66e', component.options)
    }
    module.hot.accept("./product-schema-detail.vue?vue&type=template&id=41ccc66e&", function () {
      api.rerender('41ccc66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/product-schema-detail/product-schema-detail.vue"
export default component.exports